import {
  Center,
  EmptyState as ChakraEmptyState,
  VStack
} from "@chakra-ui/react"
import * as React from "react"

export interface EmptyStateProps extends ChakraEmptyState.RootProps {
  title: string
  description?: string
  icon?: React.ReactNode
  center?: boolean
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  function EmptyState(props, ref) {
    const { title, description, icon, children, center, ...rest } = props
    const emptyState = (
      <ChakraEmptyState.Root ref={ref} {...rest}>
        <ChakraEmptyState.Content>
          {icon && (
            <ChakraEmptyState.Indicator>{icon}</ChakraEmptyState.Indicator>
          )}
          {description ? (
            <VStack textAlign="center">
              <ChakraEmptyState.Title m={0}>{title}</ChakraEmptyState.Title>
              <ChakraEmptyState.Description m={0}>
                {description}
              </ChakraEmptyState.Description>
            </VStack>
          ) : (
            <ChakraEmptyState.Title>{title}</ChakraEmptyState.Title>
          )}
          <>{children}</>
        </ChakraEmptyState.Content>
      </ChakraEmptyState.Root>
    )

    if (center) {
      return <Center>{emptyState}</Center>
    }

    return emptyState
  }
)
